import { createRoot } from "react-dom/client";
import { App } from "./App";
import { syncGoogleAnalyticsRoutePrivacy } from "./lib/google-analytics";
import { parsePublicMapPath } from "./lib/map-share";
import "./styles.css";

function syncInstallMetadata() {
  const playerRemote = location.pathname.startsWith("/pr");
  const sharedMap = Boolean(parsePublicMapPath(location.pathname));
  const description = sharedMap ? "A read-only map shared from TBLTOP." : playerRemote ? "A full-screen private player remote for the TBLTOP table." : "Turn a projector, TV, or tabletop screen into a shared game surface. TBLTOP supplies the maps, chips, cards, dice, and private player remotes.";
  const title = sharedMap ? "TBLTOP — Shared Map" : playerRemote ? "TBLTOP — Player Remote" : "TBLTOP — The table is the console.";
  document.querySelector<HTMLLinkElement>('link[rel="manifest"]')?.setAttribute("href", playerRemote ? "/player-remote.webmanifest" : "/manifest.webmanifest");
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute("content", playerRemote ? "#080a09" : "#12120f");
  document.querySelector<HTMLMetaElement>('meta[name="description"]')?.setAttribute("content", description);
  document.querySelector<HTMLMetaElement>('meta[name="apple-mobile-web-app-title"]')?.setAttribute("content", sharedMap ? "TBLTOP Map" : playerRemote ? "TBLTOP Remote" : "TBLTOP");
  document.querySelector<HTMLMetaElement>('meta[property="og:title"]')?.setAttribute("content", title);
  document.querySelector<HTMLMetaElement>('meta[property="og:description"]')?.setAttribute("content", description);
  document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]')?.setAttribute("content", title);
  document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]')?.setAttribute("content", description);
  let robots = document.querySelector<HTMLMetaElement>('meta[data-tbltop-route-robots]');
  if (sharedMap && !robots) { robots = document.createElement("meta"); robots.name = "robots"; robots.dataset.tbltopRouteRobots = "true"; document.head.append(robots); }
  if (robots) { if (sharedMap) robots.content = "noindex, nofollow, noarchive"; else robots.remove(); }
  document.title = title;
}

syncInstallMetadata();
syncGoogleAnalyticsRoutePrivacy();
window.addEventListener("popstate", () => { syncInstallMetadata(); syncGoogleAnalyticsRoutePrivacy(); });

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js?v=19", { updateViaCache: "none" }));
}

createRoot(document.getElementById("root")!).render(<App />);
